import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../../store/actions';
import load from './load';
export var changeMode = function changeMode(props) {
  return function (dispatch) {
    var id = props.id,
        mode = props.mode;
    dispatch({
      type: ACTIONS.GRID_VIEW_SET,
      view: {
        id: id,
        mode: mode
      }
    });
    return dispatch(load(_objectSpread({}, props, {
      id: id,
      mode: mode
    })));
  };
};
export default changeMode;